/**
 * Regles d'affichage de la page des sinistres lies.
 *
 * Elles vivent ici, hors du composant, parce que ce sont les deux seules regles
 * de cette page qu'un remaniement de l'habillage peut casser sans bruit. Le
 * depot n'a pas de bibliotheque de rendu : ce qui n'est pas extrait n'est pas
 * teste.
 */

/**
 * Les cles des lignes a ouvrir d'emblee : toutes.
 *
 * POURQUOI TOUT EST DEPLIE. Le contenu du groupe est exactement ce qu'on vient
 * consulter sur cette page. Le tableau qui l'a precedee demandait un clic par
 * ligne pour voir quoi que ce soit, ce qui revenait a cacher la reponse derriere
 * la question. Le repli reste offert, ligne par ligne.
 *
 * POURQUOI ON ECARTE LES ENTREES SANS IDENTIFIANT. Une cle indefinie dans
 * `expandedRowKeys` ne leve pas : le tableau ne trouve simplement aucune ligne
 * correspondante et la laisse repliee. On obtiendrait un ecran ou une ligne sur
 * deux s'ouvre, sans que rien n'explique laquelle.
 */
export function clesDepliees(liaisons) {
  if (!Array.isArray(liaisons)) return [];
  return liaisons.map((l) => l?.liaisonTrackingId).filter(Boolean);
}

/**
 * Vrai des qu'un seul dossier du groupe est moins avance que ses freres.
 *
 * Le sens de l'alerte est « au moins un dossier est en arriere », jamais
 * « tous » : c'est precisement le dossier qui traine qui merite d'etre signale.
 *
 * CE N'EST PAS UNE QUESTION DE DELAI, malgre ce que l'ancien nom du champ
 * (`enRetard`) laissait croire. Le serveur compare l'AVANCEMENT des dossiers du
 * groupe, mesure par leur statut sur le parcours d'un dossier : aucune date,
 * aucune echeance n'entre dans le calcul. Un dossier ouvert hier peut etre
 * signale, un dossier ouvert il y a deux ans peut ne pas l'etre.
 */
export function liaisonADossierMoinsAvance(liaison) {
  const membres = liaison?.membres;
  if (!Array.isArray(membres)) return false;
  return membres.some((m) => m?.moinsAvance);
}
